import request from '@/plugin/axios'

/**
 * 上传文件
 * @returns {*}
 */
export function uploadMultipleImage(params) {
    return request({
        url: '/api/admin/sysFiles/uploadMultiple',
        method: 'post',
        headers: {'Content-Type': 'multipart/form-data'},
        data: params
    });
}

export function enterpriseAuthIns(obj){
    return request({
        url:'/api/admin/sysEnterpriseAuth/enterpriseAuthIns',
        method: 'post',
        data: obj
    })
}

export function findByEntId(param){
    return request({
        url:'/api/admin/sysEnterpriseAuth/findByEntId',
        method: 'get',
        params:param
    })
}
